import ContentLoader from '@rio-cloud/rio-uikit/ContentLoader';
import { TableColumn } from './TableRow';

type ContentLoaderRowProps<T> = {
  columns: TableColumn<T>[];
};

export const ContentLoaderRow = <T extends object>({
  columns,
}: ContentLoaderRowProps<T>) => {
  return (
    <tr data-testid={'content-loader'}>
      {columns.map((c) => (
        <td key={String(c.id)}>
          <ContentLoader />
        </td>
      ))}
      <td>
        <ContentLoader />
      </td>
    </tr>
  );
};
